import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getContentItemIconFromType } from 'utils/icons';
import getContentItemType, { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
import getPictureUrl, { DIMENSIONS } from 'utils/image/getPictureUrl';
import useUniqueId from 'hooks/useUniqueId';
import FormField from 'components/FormField';
import { TinyHorizontalCard, TypeIcon } from 'components/ContentCards';
import { Menu, MenuButton, MenuItem, MenuList } from 'components/Menu';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Flex from 'components/Flex';
function ContentField(_ref) {
  var onRemoveContent = _ref.onRemoveContent,
    _ref$contents = _ref.contents,
    contents = _ref$contents === void 0 ? [] : _ref$contents,
    onOpenAssetPicker = _ref.onOpenAssetPicker,
    onOpenPlaylistPicker = _ref.onOpenPlaylistPicker;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var menuId = useUniqueId();
  var hasNoContent = contents.length === 0;
  return /*#__PURE__*/React.createElement(FormField, {
    required: true,
    as: "fieldset",
    label: t("".concat(t('form_content_plural'), " *")),
    horizontalLabelOffset: "xxs"
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, hasNoContent ? /*#__PURE__*/React.createElement(Flex, {
    border: "dashed",
    borderRadius: "small",
    p: "s",
    minHeight: 61
  }, /*#__PURE__*/React.createElement(Text, {
    dimmed: true
  }, t('error_no_content_selected'))) : contents.map(function (item) {
    var id = item.id,
      name = item.name;
    var rawType = getContentItemType(item);
    var icon = getContentItemIconFromType(rawType);
    var type = t(getContentItemTypeTranslationKey(rawType));
    return /*#__PURE__*/React.createElement(TinyHorizontalCard, {
      key: id,
      title: name,
      isImageLeft: true,
      imageSource: getPictureUrl({
        id: item.thumbnailId,
        dimensions: DIMENSIONS.TINY_CARD
      }),
      icon: type === 'playlist' ? 'playlist' : icon,
      subtitle: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TypeIcon, {
        name: icon
      }), type),
      buttonProps: {
        icon: 'x',
        label: type === 'playlist' ? t('actions_remove_specific_playlist', {
          name: name
        }) : t('actions_remove_specific_asset', {
          name: name
        }),
        onClick: function onClick() {
          return onRemoveContent === null || onRemoveContent === void 0 ? void 0 : onRemoveContent(id);
        }
      }
    });
  }), /*#__PURE__*/React.createElement(Menu, {
    id: menuId
  }, /*#__PURE__*/React.createElement(MenuButton, {
    iconRight: "chevron",
    icon: "plus",
    "aria-label": t('actions_add_content'),
    size: "medium"
  }, t('actions_add_content')), /*#__PURE__*/React.createElement(MenuList, null, /*#__PURE__*/React.createElement(MenuItem, {
    onClick: onOpenAssetPicker
  }, t('actions_add_asset')), /*#__PURE__*/React.createElement(MenuItem, {
    onClick: onOpenPlaylistPicker
  }, t('actions_add_playlist'))))));
}
export default ContentField;